import React from "react";
import ReactDOM from "react-dom";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from 'array-move';
import firebase from "firebase/app";
import "firebase/firestore";
import "./favs.css";
import Fav from './fav'

function Favs({ favs }) {

    const SortableItem = SortableElement(({fav, index, key}) => (
        <Fav fav={fav} index={index} key={key}></Fav>
    ))

    const SortableList = SortableContainer(({favs}) => {
        return (
            <div className="favs">
                {favs.map((fav) => (
                    <SortableItem
                        fav={fav}
                        index={favs.findIndex(x => x.id === fav.id)}
                        key={fav.id}
                    />
                ))}
            </div>
        );
    })

    function onSortEnd({ oldIndex, newIndex }) {
        if (oldIndex !== newIndex) {
            favs = arrayMove(favs, oldIndex, newIndex)
            ReactDOM.render(
                <Favs favs={favs} />,
                document.querySelector(".favs-container")
            );
            favs.forEach((fav) => {
                if (fav.countries.length < 1) {
                    document.querySelector(`.fav .info .${fav.id}`).style.display = "none";
                }
            });

            let user = firebase.auth().currentUser;

            let db = firebase.firestore(),
                userRef = db.collection("users").doc(user.uid);
            userRef.set({
                favourites: favs,
            });
        }
    }

    return (
        <SortableList
            favs={favs}
            onSortEnd={onSortEnd}
            lockAxis="y"
            pressDelay={200}
        />
    );
}

export default Favs;
